<template>
  <van-cell class="his-cell-item" center>
    <!-- Deposit Cell -->
    <template v-if="type === 'deposit'">
      <template slot="title">
        <div class="fw500 flex-center cell-title">
          Purchase Order （ {{ item.coins_count }} <img src="@/assets/images/gcoin.png" width="14px" />）
        </div>
      </template>
      <template slot="label">
        {{ label }}
      </template>
      <span :class="['his-item-value', item.status === 2 ? 'fail' : '']">
        {{ statusMap[item.status] }}
      </span>
    </template>
    <!-- Usage Cell -->
    <template v-if="type === 'usage'">
      <template slot="title">
        <div class="fw500 flex-center cell-title">
          {{ item.detail.book_name }}
        </div>
      </template>
      <template slot="label">
        {{ label }}
      </template>
      <div class="cell-value">
        <img src="@/assets/images/gcoin.png" width="20px" />
        <span class="value-text">
          {{ item.coins_count }}
        </span>
      </div>
    </template>
  </van-cell>
</template>

<script>
const statusMap = {
  0: "Pending",
  1: "Done",
  2: "Failed"
};

export default {
  props: {
    type: String,
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    this.statusMap = statusMap;
    return {};
  },
  computed: {
    label() {
      if (this.type === "deposit") {
        return String(this.item.created_at).replace("T", " ");
      } else {
        return this.item.detail.chapter_title;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.his-cell-item {
  &::v-deep {
    .van-cell__title {
      flex: 2;
    }
    .van-cell__value {
      flex: 1;
    }
  }
  .cell-title {
    font-weight: 500;
    padding-top: 3px;
    padding-bottom: 3px;
    justify-content: flex-start;
    img {
      margin: 0 4px;
    }
  }
  .cell-label {
    font-weight: 400;
    font-size: $fs-xs;
    color: $fc-grey;
  }
  .cell-value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .value-text {
      color: $color-golden;
      margin-left: 5px;
    }
  }
  .his-item-value {
    color: $fc-black;
    font-weight: 500;
    &.fail {
      color: $color-red;
    }
  }
}
</style>
